import {Injectable} from '@angular/core';
import {Service} from '../../common/service.class';
import {MedicalEducation} from './medical-education.model';
import {UserModelService} from '../../common/user-model.service';

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
@Injectable()
export class MedicalEducationService extends UserModelService<MedicalEducation> {

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, 'medicalEducation', MedicalEducation);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/education/medical/medical-education.service.ts